export default {
  dbi_intelligence: 'Intelligence',
  dbi_confirm: 'Confirm',
  dbi_no_filter_changes: 'No changes to the filter',
  dbi_note: 'Note',
  dbi_cancel: 'Cancel',
  dbi_back: 'Back',
  dbi_reset: 'Reset',
  dbi_more_filter: 'More Filter',
  dbi_collapse_filter: 'Collapse Filter',
  dbi_filter_show: 'Show',
  dbi_actions: 'Actions',
  dbi_more: 'More',
  dbi_details: 'Details',
  dbi_sortby: 'Sort By',
  dbi_please_select: 'Please Select',
  dbi_follow: 'Follow',
  dbi_following: 'Following',
  dbi_detail_follow: 'Follow',
  dbi_detail_following: 'Following',
  dbi_menu_following: 'Following',
  dbi_pie_chart: 'Pie chart',
  dbi_bar_chart: 'Bar chart',
  dbi_line_chart: 'Line chart',
  dbi_world_map_chart: 'world map chart',
  dbi_stacked_line_chart: 'Stacked line chart',
  dbi_tree_map: 'Rectangular Tree Diagram',
  dbi_disabled_chart_tips: 'The current visualization is not available for this metric.',
  dbi_sorted_by: 'Sorted by {sortData}',
  dbi_date: 'Date',
  dbi_value: 'Value',
  dbi_time: 'Time',
  dbi_type: 'Type',
  dbi_all_select: 'All',
  dbi_all: 'All',
  dbi_day: 'Day',
  dbi_week: 'Week',
  dbi_month: 'Month',
  dbi_hour: 'Hour',
  dbi_hour_tooltip: 'Due to large data volume, Steam Hourly CCU does not support time ranges exceeding 7 days.',
  dbi_days: 'Days',
  dbi_weeks: 'Weeks',
  dbi_months: 'Months',
  dbi_daily: 'Daily',
  dbi_weekly: 'Weekly',
  dbi_monthly: 'Monthly',
  dbi_quarterly: 'Quarterly',
  dbi_annually: 'Annually',
  dbi_game: 'Game',
  dbi_search_result: 'Search Result',
  dbi_game_selection: 'Game Selection',
  dbi_select_games: 'Select Games',
  dbi_games: 'Games',
  dbi_no_data_please_add: 'No Data, please Add',
  dbi_game_lower: 'game',
  dbi_key_metrics: 'Key Metrics',
  dbi_search_any_game: 'Search any game',
  dbi_Choose_up_to_games: 'Choose up to ',
  dbi_Choose_up_to_games_end: ' games',
  dbi_search_any_company: 'Search any company',
  dbi_please_a_select_game: 'Please select a game',
  dbi_please_a_select_company: 'Please select a company',
  dbi_no_search_results: 'No search results',
  dbi_menu_search_page_group: 'Page',
  dbi_add: 'ADD',
  dbi_operation_successfully_tips: 'Successful operation!',
  dbi_operation_failly_tips: 'Failure operation , please try again.',
  // 统一 operation 提示
  dbi_common_operation_succeed_tips: 'Successfully operated!',
  dbi_common_operation_failed_tips: 'Operation failed!',
  dbi_download_settings: 'Download Settings',
  dbi_source_quality: 'Source Quality',
  dbi_alinea_release_to_be_decided: 'To Be Decided',
  dbi_alinea_release_upcoming: 'Upcoming',
  dbi_download_title_tips: 'You can choose the aggregated or separated method to display the data with the selected filters.',
  dbi_download: 'Downloads',
  dbi_label_summary: 'Summary',
  dbi_label_financials: 'Financials',
  dbi_label_people: 'People',
  dbi_label_metrics: 'Metrics',
  dbi_label_metrics_category: 'Metrics Category',
  dbi_label_visualization_metrics: 'Visualization Metrics',
  dbi_label_palyform_Setting: 'Platform Settings',
  dbi_download_tips:
    'Separate by time:will return the data separated in daily grabularity. Aggreated method:will return the data with current filter. Displayed data:All rows on current page.',
  dbi_jumpdashboard_modal_tips:
    'You are currently accessing third-party Intelligence data. As you have Dashboard access for this game, would you like to directly proceed to the Dashboard section to view the real data?',
  dbi_goto_dashboard: 'OK! Enter Dashboard',
  dbi_stay_intelligence: 'NO, Stay here',
  dbi_no_prompt_again: `Don't prompt again`,
  dbi_no_show_again: "Don't show again",
  dbi_filters_redirect_tips_title: 'Redirect to Selected Filters?',
  dbi_filters_redirect_tips_desc1: 'You will be redirected to the filter conditions for {metricInfo}.',
  dbi_filters_redirect_tips_desc2: 'The granularity and time range of the time filter may be adjusted.',
  dbi_tip: 'Tips',
  dbi_label_basic_info: 'Basic information',
  dbi_label_basic_info_optional: 'Basic information(optional)',
  dbi_label_release_date: 'Release Date',
  dbi_label_company_info: 'Company information',
  dbi_label_genre: 'Genre',
  dbi_label_data_calculation: 'Data Calculation',
  dbi_label_data_calculation_change: 'Data Calculation Change',
  dbi_label_data_settings: 'Data Settings',
  dbi_label_time_settings: 'Time Settings',
  dbi_label_platform_settings: 'Platform Settings',
  dbi_label_anchors_settings: 'Anchors Settings',
  dbi_label_game_settings: 'Game Settings',
  dbi_label_time_settings_tips:
    'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
  dbi_label_chart: 'Chart',
  dbi_label_rankings: 'Rankings',
  dbi_label_aggregated: 'Aggregated',
  dbi_label_separate_by_platform: 'Separate by Platform',
  dbi_label_show_top_influencers: 'Show top influencers',
  dbi_label_separate_by_games: 'Separate by games',
  dbi_label_edition_settings: 'Edition Settings',
  dbi_label_separate_by_edition: 'By Edition',
  dbi_label_region_settings: 'Region Settings',
  dbi_label_country_settings: 'Country Settings',
  dbi_label_segment_settings: 'Segment Settings',
  dbi_label_segment_settings_product: 'Segment Settings',
  dbi_label_genre_settings: 'Genre Settings',
  // dbi_label_device_settings: 'Device Settings',
  // dbi_label_npd_device_settings: 'Device Settings(NPD)',
  // dbi_label_famitsu_device_settings: 'Device Settings(Famitsu)',
  // dbi_label_gsd_device_settings: 'Device Settings(GSD)',
  // dbi_label_mscience_device_settings: 'Device Settings(Mscience)',
  dbi_label_device_settings: 'Platform Settings',
  dbi_label_npd_device_settings: 'Platform Settings(NPD)',
  dbi_label_famitsu_device_settings: 'Platform Settings(Famitsu)',
  dbi_label_gsd_device_settings: 'Platform Settings(GSD)',
  dbi_label_mscience_device_settings: 'Platform Settings(Mscience)',
  dbi_label_separate_by_time: 'Separate by Time',
  dbi_label_separate_by_country: 'Separate by Countries',
  dbi_label_separate_by_region: 'Separate by Regions',
  dbi_label_separate_by_time_combine: 'By Time',
  dbi_label_separate_by_country_combine: 'By Countries',
  dbi_label_separate_by_region_combine: 'By Regions',
  // dbi_label_separate_by_device_combine: 'By Device',
  dbi_label_separate_by_device_combine: 'By Platform',
  dbi_label_separate_by_segment_combine: 'By Segment',
  dbi_label_separate_by_genres: 'Separate by Genres',
  dbi_label_separate_by_sub_genres: 'Separate by Sub Genres',
  dbi_label_ratio: 'Ratio',
  dbi_label_data_amount: 'Data Amount',
  dbi_export_all_data: 'Export all data',
  dbi_export_all_tip: '100,000 Rows limited',
  dbi_select_top: 'Select Top',
  dbi_label_download_type: 'Download Type',
  dbi_download_type_by_game: 'By Game (Time Trend)',
  dbi_download_type_by_game_tip: 'Track changes over time for each game.',
  dbi_download_type_by_time: 'By Time (Rank Changes)',
  dbi_download_type_by_time_tip: 'View leaderboard snapshots across different time periods.',
  dbi_export_checked_lines: 'Export selected',
  dbi_select_top_over_maximum_value: '· Over the Maximum value',
  dbi_select_top_must_more_than_one: '· Must more than one',
  dbi_download_max_value_tip:
    'The maximum number of games available for download under the current filter is {maxValue}.',
  dbi_label_file_format: 'File Format',
  dbi_label_excel: 'Excel',
  dbi_label_csv: 'CSV',
  dbi_label_other_settings: 'Other Settings',
  dbi_mobile_games: 'Mobile Games',
  dbi_mobile_games_pc: 'Both',
  dbi_mobile_combine: 'Cross-Platform',
  dbi_pc_games: 'PC Games',
  dbi_console_games: 'Console Games',
  dbi_pcconsole_games: 'PC & Console Games',
  dbi_company_games: 'Company',
  dbi_total_games: 'Total Games',
  dbi_device: 'Device',
  dbi_device_dimension_data_unavailable: 'Device dimension data unavailable',
  dbi_company: 'Company',
  dbi_company_lower: 'company',
  dbi_source: 'Source',
  dbi_data_source: 'Data Source',
  'Data Source': 'Data Source',
  dbi_platform: 'Platform',
  Platform: 'Platform',
  dbi_platform_ios: 'iOS',
  dbi_platform_android: 'Android',
  dbi_platform_unified: 'Unified',
  dbi_platform_wechat: 'WeChat',
  dbi_platform_douyin: 'Douyin',
  'Segment For Sales': 'Segment For Sales',
  dbi_digitalARPPU_desc: `Please note that ARPPU for 1 segment or all 6 segments are reliable.<br/>
Definition: ARPPU = revenue / number of unique payers. MScience can't provide product purchase list of any single payers due to the protection of user privacy. User deduplication is not available. The ARPPU of multiple segments is smaller.<br/>
Example:  Game A had 1 user who purchased the base game for 20 and spent 50 on in-store purchases. In this case, the ARPPU for the base game would be 20, the MTX ARPPU would be 20, the MTX ARPPU would be 50, and the actual combined ARPPU (base game + MTX) would be 70. However, since MScience can not deduplicate users, the average ARPPU becomes(50 + 20)/(1+1)=20)/(1+1)=35. <br/>When you tick all 6 segments, MScience provides total paying user numbers, thus making the data referenceable.`,
  dbi_publisher: 'Publisher',
  dbi_product_list: 'Product list',
  dbi_product_list_total_count: '{count} items in total',
  dbi_product_list_total_count_singular: '{count} item in total',
  dbi_publisher_hover_tip: 'Click here to view the product list of this company',
  dbi_publisher_class: 'Publisher Class',
  dbi_publisher_class_hobbyist: 'Hobbyist',
  dbi_publisher_class_indie: 'Indie',
  dbi_publisher_class_aa: 'AA',
  dbi_publisher_class_aaa: 'AAA',
  dbi_publisher_region: 'Publisher Region',
  dbi_developer: 'Developer',
  dbi_main_genre: 'Main Genre',
  dbi_sub_genre: 'Sub Genre',
  dbi_super_genre: 'Super Genre',
  dbi_level_1_genre: 'Level-1 Genre',
  dbi_level_2_genre: 'Level-2 Genre',
  dbi_level_3_genre: 'Level-3 Genre',
  dbi_level_4_genre: 'Level-4 Genre',
  dbi_main_sub_genre: 'Main + Sub Genre',
  dbi_genre_category: 'Genre Category',
  dbi_game_platform: 'Game Platform',
  dbi_game_add: 'Add',
  dbi_success_follow: 'Successfully followed!',
  dbi_failed_follow: 'Failed followed, please try again.',
  dbi_top10_revenue: 'Top 10 by revenue',
  dbi_top10_pheat: 'Top 10 by P.Heat',
  dbi_top10_digital: 'Top 10 by Digital Revenue',
  dbi_top10_sum_rev: 'Top 10 by Sum Revenue',
  dbi_type_games_only: '({type} Only)',
  dbi_revenue_setting: 'Revenue Settings',
  dbi_revenue_range_unit_setting: 'Revenue Range Settings',
  dbi_physical_revenue_setting: 'Physical Revenue Settings',
  dbi_price_setting: 'Steam Price Settings',
  dbi_pcu_setting: 'PCU Settings',
  dbi_digital_revenue_setting: 'Digital Revenue Settings',
  dbi_premium_revenue_setting: 'Steam Premium Revenue Settings',
  dbi_revenue_range: 'Revenue Range',
  dbi_revenue_range_unit: 'Revenue Range ($)',
  dbi_arpu_range: 'ARPU Range',
  dbi_active_users_range: 'Active Users Range',
  dbi_downloads_range: 'Downloads Range',
  dbi_rpd_range: 'RPD Range',
  dbi_d2_range: 'D2 Range',
  dbi_d3_range: 'D3 Range',
  dbi_d7_range: 'D7 Range',
  dbi_d15_range: 'D15 Range',
  dbi_d31_range: 'D31 Range',
  dbi_revenue_scope_excluding_store_fees: 'Excluding Store Fees',
  dbi_revenue_scope_including_store_fees: 'Including Store Fees',
  dbi_revenue_scope_exclude_store_fees: 'Exclude Store Fees',
  dbi_revenue_scope_tip_excluding: 'Revenue net of channel fees (∼30%), as reported by Sensor Tower',
  dbi_revenue_scope_tip_including: 'Gross revenue estimate, adjusted for 30% channel fee assumption',
  dbi_download_settings_revenue_scope_tip: 'Revenue scope align with the filter.',
  dbi_pcu_range: 'PCU Range',
  dbi_revenue_growth: 'Revenue Growth',
  dbi_digital_revenue_range: 'MScience Digital Revenue Range',
  dbi_physical_revenue_range: 'NPD Physical Revenue Range',
  dbi_premium_revenue_range: 'Steam Premium Revenue Range',
  dbi_price_range: 'Steam Price Range',
  dbi_minimum: 'Minimum',
  dbi_maximum: 'Maximum',
  dbi_revenue_error_format_tip: 'Input error, please check the format is correct.',
  dbi_number_range_two_decimal_tip: 'Up to 2 decimal places allowed.',
  dbi_less_than: '< Less than',
  dbi_greater_than: '> Greater than',
  dbi_greater_than_equal: '≥ Greater than or equal to',
  dbi_less_than_equal: '≤ Less than or equal to',
  dbi_equal_to: '= Equal to',
  dbi_please_input: 'Please input',
  dbi_input_range: 'Input range',
  dbi_cannot_be_null: `Can't be null.`,
  dbi_max_less_min: 'The maximum value cannot be less than the minimum value',
  dbi_min_greater_max: 'The minimum value cannot be greater than the maximum value',
  dbi_input_growth: 'Input growth',
  dbi_input_overlap: 'Input overlap',
  dbi_input_growth_percentage: 'Input percentage',

  dbi_release_date: 'Release Date',
  dbi_release: 'Release',
  dbi_delete: 'Delete',
  dbi_disable: 'Disable',

  dbi_download_chart: 'Download the Chart',
  dbi_download_data: 'Download the Data',
  dbi_learnmore: 'Learn More',
  dbi_search_loading: 'Loading...',
  dbi_search_empty: 'No Data',
  dbi_search_no_result: 'No results found.',
  dbi_no_data_available: 'No data available under the selection.',
  dbi_no_available: 'No data available',
  dbi_no_data_available_gsd:
    'The data is only available for european countries in weekly basis, please switch to week for the data. ',
  dbi_no_data_available_store_rank: 'The game is not listed on this Steam rank',
  dbi_no_data_available_top_100_seller_rank: 'The game has not been on the top 100 seller rank',
  dbi_no_data_available_store_rank_daily_only:
    'This ranking list is updated on a daily basis; weekly and monthly granularities are unavailable.',
  dbi_select_all: 'Select All',
  dbi_clear_all: 'Clear All',
  dbi_data_privacy: 'Data Privacy',
  dbi_close: 'Close',
  dbi_data_privacy_got_it: 'Got it!',

  dbi_mobile: 'Mobile',
  dbi_pc: 'PC',
  dbi_console: 'Console',
  dbi_combine: 'PC & Console',
  dbi_pc_console_combine: 'PC & Console',
  dbi_console_version: 'Console',
  dbi_single_country: 'Single Country',
  dbi_multiple_countries: 'Multiple Countries',
  dbi_single_region: 'Single Region',
  dbi_multiple_regions: 'Multiple Regions',
  dbi_country: 'Country',
  dbi_region: 'Region',
  dbi_select_region: 'Select Region',
  dbi_hot: 'Hot',
  dbi_hot_metrics: 'Hot',
  dbi_ranking: 'Ranking',
  dbi_quantity: 'Quantity',
  dbi_country_region: 'Country / Region',
  dbi_rank: 'Rank',
  dbi_rank_trend: 'Ranking Trend',
  dbi_rank_loading: 'Rank loading...',
  dbi_count: 'Count',
  dbi_mentions: 'Mentions',
  dbi_default_search_placeholder: 'Search any game in the table',
  dbi_table_search_placeholder: 'Search any {domainName} in the table',
  dbi_menu_search_placeholder: 'Search menus',
  dbi_detail_trend: 'Trends',
  dbi_cascader_placeholder: 'Select any platform',
  dbi_detail_user_engagement_ampere: 'Countries Share of ',
  dbi_detail_players_by_country: 'Players \nby country',
  dbi_composed_label_trends: ' Trends',
  dbi_detail_price_trend: 'Price Trends($)',
  dbi_detail_earliest_date: `Earliest Date of Data`,
  dbi_detail_latest_date: `Latest Date of Data`,
  dbi_detail_current_data_date: `Current Data Date`,
  dbi_detail_latestdate_info: 'The SensorTower Lifetime Retention data source is no longer updated. Data is current as of 2025-07-01.',
  dbi_detail_editions_share: `Editions Share`,
  dbi_detail_countries_share: `Countries Share`,
  dbi_detail_global_data: `Global Data`,
  dbi_detail_pcu_and_acu: `PCU and ACU`,
  dbi_detail_channels_share: `Channels Share`,
  dbi_channel: `Channel`,
  dbi_offline: 'OffLine',
  dbi_inactive: 'Inactive',
  dbi_inactive_hover: 'This app is inactive across all countries.',
  dbi_offline_hover: 'This app has been removed from the store.',
  dbi_earliest_data: 'Earliest Data',
  dbi_since_release: 'Since Release',

  // 国家列表相关
  dbi_global: 'Global',
  dbi_world_wide: 'World Wide',
  dbi_global_wo_china: 'Global except China mainland',
  dbi_total: 'Total',
  dbi_others: 'Others',
  dbi_early_access: 'Early Access',
  dbi_full_release: 'Full Release',
  dbi_off_line: 'Offline',
  dbi_beta: 'Beta',
  dbi_alpha: 'Alpha',
  dbi_released: 'Released',
  dbi_cancelled: 'Cancelled',
  // 指标名，页签名
  dbi_active_users: 'Active Users',
  dbi_revenue: 'Revenue',
  dbi_ampere: 'Ampere',
  dbi_other_vendor: 'Other Vendor',
  dbi_revenue_$: 'Revenue($)',
  dbi_downloads: 'Downloads',
  dbi_rpd: 'RPD',
  dbi_retention: 'Retention',
  dbi_demographics: 'Demographics',
  dbi_metrics_table: 'Metrics Table',
  dbi_pcu: 'PCU',
  dbi_mscience: 'Mscience',
  dbi_digital_revenue: 'Digital Revenue',
  dbi_digital_revenue_$: 'Digital Revenue($)',
  dbi_digital_revenue_$_only_us: 'Digital ARPPU($) (US only)',
  dbi_physical_revenue: 'Physical Revenue',
  dbi_japan_sales: 'Japan Sales',
  dbi_steam_sales: 'Steam Sales',
  dbi_mau: 'MAU',
  dbi_wau: 'WAU',
  dbi_dau: 'DAU',
  dbi_lifetime_players: 'Lifetime Players',
  dbi_new_release: 'New Release',
  dbi_area_region: 'Region',
  dbi_steam_id: 'Steam id',
  dbi_area_north_america: 'North America',
  dbi_area_europe: 'Europe',
  dbi_label_search: 'Search',
  dbi_search_ranking_here: 'Search Ranking Here',
  dbi_hot_tags: 'Hot Tags',
  dbi_hot_tags_placeholder: 'Select any tag',
  dbi_hot_tags_tooltip: 'Popular game categories, with game lists selected from default filter selections. For any questions, feel free to contact sallyxue',
  dbi_upcoming: 'Upcoming',
  dbi_xbox_upcoming: 'Xbox Upcoming',
  dbi_benchmark: 'Benchmark',
  dbi_acu: 'ACU',
  // dbi_newzoo_metrics: 'User Engagement',
  dbi_newzoo_metrics: 'No-Update',
  dbi_ampere_metrics: 'User Engagement',
  dbi_monthly_retention: 'Monthly Retention',
  dbi_lifetime_retention: 'Lifetime Retention',
  dbi_lifetime_retention_tips: 'Global and all-time data only.You can display the data without granularity limited.',
  dbi_overview: 'Overview',
  dbi_gameinfo: 'Game Info',
  dbi_kpi_overview: 'KPI Overview',
  dbi_kpi_trends: 'KPI Trends',
  dbi_kpi_trends_jump: 'For more game metrics, please refer to ',
  dbi_stats: 'Stats',
  dbi_insights: 'Insights',
  dbi_countries: 'Countries',
  dbi_storeRank: 'Store Rank',
  dbi_overlap: 'Overlap',
  dbi_steam_overlap: 'Overlap',
  dbi_opinions: 'Opinions',
  dbi_streaming: 'Streaming',
  dbi_data_report: 'Data Report',
  dbi_dataBrain_calibration: 'DataBrain Calibration',
  'Total Revenue($)': 'Total Revenue($)',
  'Lifetime Total Revenue($)': 'Lifetime Total Revenue($)',
  'Base Game Sales Units': 'Base Game Sales Units',
  'Lifetime Base Game Sales Units': 'Lifetime Base Game Sales Units',
  dbi_us_only: `US data only`,
  dbi_japan_only: 'Japan data only',
  dbi_global_only: `Global data only`,
  dbi_pcu_steam_only: `Steam data only`,
  dbi_steam_only: `Steam platform and global data only`,
  dbi_change: 'Change',
  dbi_rank_change: 'Change',
  dbi_download_language: 'Language',
  dbi_download_language_option_cn: 'Chinese',
  dbi_download_language_option_en: 'English',
  dbi_detail_games_share: `Games Share`,
  dbi_description: 'Description',

  dbi_no_data: 'No result found',
  dbi_data_preview: 'Data Preview',
  dbi_manage: 'Manage',
  dbi_current_games: 'Current Game',
  dbi_newrelease_upcominggames: 'New Release & Upcoming Games',
  dbi_heat_range: 'P.Heat Range',
  dbi_search_for_source: 'Search for source',
  dbi_search_for_metrics: 'Search for metrics',
  dbi_arpu: 'ARPU',
  dbi_filter_segment: 'Segment',
  dbi_ai_hub_reports: 'AI Hub Reports',
  dbi_ai_hub_reports_intro: 'In this section, we present you AI-related reports and game demo videos.',
  dbi_ai_hub_reports_search: 'Search AI reports',
  dbi_ai_hub_reports_game_ai: 'Game AI',
  dbi_ai_hub_reports_ai_assets: 'AI Assets',
  dbi_filter_segment_engagement: 'Engagement Level',
  dbi_filter_segment_engagement_two_a: 'Game A Playtime',
  // dbi_filter_segment_engagement_two_a: 'Game A Engagement',
  // dbi_filter_segment_engagement_two_b: 'Game B Engagement',
  dbi_filter_segment_engagement_two_b: 'Game B Playtime',
  dbi_filter_segment_engagement_two_b_level: 'Game B Playtime',
  // dbi_filter_segment_engagement_two_b_level: 'Game B Engagement Level',
  dbi_filter_group_popular: 'Popular',
  dbi_filter_group_company: 'Company',
  // Performance Summary & Edition List tooltips
  dbi_performance_summary_tip: 'Click "Stats" above to view more details from {sensorTower} Sensor Tower.',
  dbi_edition_list_tip: 'The statistics period of each metric is aligned with the time range selected in the cards above.',
  dbi_filter_group_game_performance: 'Game Performance',
  dbi_filter_group_sensor_tower: 'Sensor Tower',
  dbi_filter_group_app_magic: 'App Magic',
  dbi_filter_group_igdb: 'IGDB',
  dbi_filter_group_mscience: 'Mscience',
  dbi_filter_group_steam: 'Steam',
  dbi_filter_group_gsd: 'GSD',
  dbi_filter_group_npd: 'NPD',
  dbi_wishlists_range: 'Wishlists Range',
  dbi_segment_lte_2h: '≤2h',
  dbi_segment_greater_2h: '>2h',
  dbi_segment_greater_10h: '>10h',
  dbi_segment_greater_20h: '>20h',
  dbi_segment_greater_50h: '>50h',
  dbi_segment_greater_100h: '>100h',
  dbi_segment_greater_200h: '>200h',
  dbi_region_segment_global: 'Global',
  dbi_region_segment_na: 'US & Canada',
  dbi_region_segment_chn: 'China',
  dbi_region_segment_asia: 'Asia (except China)',
  dbi_region_segment_we: 'Western Europe',
  dbi_region_segment_ee: 'Eastern Europe',
  dbi_region_segment_others: 'Others',
  dbi_region_segment_btnname: 'Region/Country',
  dbi_segment_rank_trend: 'Rank Trend',
  dbi_segment_market_count: 'Market Count',
  dbi_switch_align_to_release: 'Align to Release',
  dbi_segment_rank_trend_avg_ranking_tips:
    'The calculation of the average ranking includes only data from the top 500 games',
  dbi_segment_avg_ranking: 'Avg Ranking',
  dbi_segment_latest_ranking_filtered: 'Ranking of the Last Day',
  dbi_retention_curve: 'Retention Curve',
  dbi_label_new_release_games: 'New Release Games',
  dbi_label_upcoming_games: 'Upcoming Games',
  dbi_label_mobile_games: 'Mobile Games',
  dbi_label_pc_games: 'PC Games',
  dbi_label_console_games: 'Console Games',
  dbi_global_initial_launch: 'Global Initial Launch',
  dbi_new_market_entry: 'New Market Entry',
  dbi_please_select_metrics: 'Please select Metrics',
  dbi_all_metrics: 'All Metrics',
  dbi_combine_console_data: 'Alinea Analytics Data',
  dbi_storage_required: 'Storage Required',
  dbi_genre_main: 'Main',
  dbi_genre_sub: 'Sub',
  dbi_release_date_by_platform: 'Release Date by Platform',
  dbi_release_date_full_release: 'Release Date',
  dbi_release_date_new: 'Release Date',
  dbi_release_region: 'Region',
  dbi_release_phase: 'Phase',
  dbi_date_joined_xbox_game_pass: 'Date joined Xbox Game Pass',
  dbi_game_languages: 'Game Language',
  dbi_select_any_tag: 'Select Any Tag',
  dbi_common_data_from_tips: 'Data of {metric} comes from {dataSource}.',
  dbi_metric_dataof_generatedby: 'Data of {sourceName} generated internally by ',
  dbi_metric_table_head_datasource: 'Data Source: ',
  dbi_metric_dataof_generatedby_suf: ' ',
  dbi_metric_data_of_generated_by: "The raw data comes from {steam}'s publicly available player game library.",
  dbi_by_device: 'By Device',
  dbi_separate_by_device: 'By Device',
  dbi_pc_console_download_by_device_tip:
    'Data from Mscience and Alinea Analytics is unavailable by device,  only provides data by platform.',
  dbi_by_platform: 'By Platform',
  dbi_avg_mau: 'Avg MAU',
  dbi_total_reviews: 'Total Reviews',
  dbi_data: 'Data',
  dbi_unfollow_goto_manage: 'If you want to unfollow the game. please go to "manage" page.',
  dbi_countries_pcu: `Global Data of PCU and ACU`,
  dbi_countries_digital: `Countries Share of Digital Revenue`,
  dbi_countries_physical: `Countries Share of Physical Revenue`,
  dbi_trends_digital: `Digital Revenue Trends`,
  dbi_trends_physical: `Physical Revenue Trends`,
  dbi_countries_japansales: `Japan Sales Trends`,
  dbi_trends_japansales: `Japan Sales Trends`,
  dbi_trends_pcu: `PCU Trends`,
  dbi_trends_gsd: `GSD Sales Data Trends`,
  dbi_countries_gsd: `Countries Share of GSD Sales Data`,

  dbi_cross_mobile_usage: `Cross Mobile Usage`,
  dbi_cross_mobile_affinity: `Cross Mobile Affinity`,
  dbi_selected_multiple_months: `Multiple months can be selected, and the data is exported in a single month.`,
  dbi_selected_multiple_country: `Multiple countries can be selected, and the data is exported in a single country.`,
  dbi_game_detail_countries: 'Countries',
  dbi_game_detail_region: 'Regions',
  dbi_selector_game_type: 'Game Type',
  dbi_selector_game_type_label: 'Type',
  dbi_cancel_prohibited: 'Cancellation prohibited',
  dbi_game_comparison_table: 'Game Comparison Table',

  MScience: 'MScience',
  GSD: 'GSD',
  NPD: 'NPD',
  DataBrain: 'DataBrain',
  dbi_segment_rank_trend_avg_ranking_tips_title: 'The calculation of average ranking only Includes -',
  dbi_segment_rank_trend_avg_ranking_tips_appstore:
    'Appstore: Top 500 games from Top Free and Top Paid rankings, top 200 games from Top Grossing rankings',
  dbi_segment_rank_trend_avg_ranking_tips_googlePlay:
    'Google Play: Top 50 games from Top Free, Top Paid and Top Grossing rankings',

  dbi_segment_rank_trend_avg_ranking_tips_title_combine:
    'The calculation of the average ranking only includes the range of rankings that can be retrieved from each store, for example:',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_steam_top_seller:
    'Extracting top 6,648 games from Steam Top Seller rankings',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_epic_top_seller:
    'Extracting top 100 games from Epic Games Top Seller rankings',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_playStation_best_selling:
    'Extracting top 9,984 games from PlayStation Best Selling rankings',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_xbox_best_rated:
    'Extracting top 1,000 games from Xbox Best Rated rankings',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_nintendo_best_seller:
    'Extracting top 243 games from Nintendo Best Seller rankings',

  dbi_segment_rank_trend_dod: 'DoD Change',
  dbi_segment_rank_trend_period: 'Period Change',
  dbi_segment_rank_trend_dod_desc: 'Display the ranking trend comparison with the previous day.',
  dbi_segment_rank_trend_period_desc: 'Display the ranking trend comparison with the last day of the prior period.',
  dbi_segment_rank_trend_avg: 'Average Ranking Trend',

  dbi_data_ai_no_update_tip:
    // "Since{SensorTower} has acquired{DataAi},{DataAi}'s data will no longer be updated starting from November 2024, but historical data will be retained. For future mobile game data, please refer to{SensorTower}. DataBrain will promptly update any data refreshes from the{SensorTower} platform to ensure consistency with the platform's data.",
    "Since Sensor Tower has acquired data.ai, data from data.ai will no longer be updated starting in November 2024, but historical data will be retained. For future mobile game data, please refer to Sensor Tower. DataBrain will continue to update Sensor Tower's platform data. In early November, we began retrieving daily, weekly, and monthly data for countries like Norway and Romania. The monthly data has been backfilled to 2017. However, due to the large volume of daily and weekly data, we are still planning the strategy.",
  dbi_only_data_ai_no_update_tip:
    // "Since{SensorTower} has acquired{DataAi},{DataAi}'s data will no longer be updated starting from November 2024, while historical data will be retained. For future mobile game data, please refer to{SensorTower}.",
    "Since Sensor Tower has acquired data.ai, data.ai's data will no longer be updated starting from November 2024, while historical data will be retained. For future mobile game data, please refer to Sensor Tower.",
  dbi_sensor_tower_data_model_update_tip:
    "DataBrain switched to Sensor Tower's new data model (integrating data.ai) on August 18, 2025, covering mobile Revenue, Downloads, and Active Users data since 2012.",
  'Steam All Reviews': 'Steam All Reviews',
  'Steam All Reviews Positive%': 'Steam All Reviews Positive%',
  'Steam Added Positive%': 'Steam Added Positive%',
  dbi_store_rank_download_tips_title: 'Support multi-day downloads',
  dbi_store_rank_region_filter_top_sellers_only: 'Region filter only for Top Sellers',
  dbi_public_data_entityType: 'entityType',
  dbi_download_modal_stick_tips: 'The maximum number of rows in the download file is 100,000.',
  dbi_mobile_download_modal_stick_tips:
    'The maximum number of rows in the download file is 100,000. For example, Top150 games choose 6 months to download by time and country, the maximum data will be 150*6*113=101,700 rows.',
  dbi_country_flter_applies: 'The country filter applies to the Top Sellers only.',
  dbi_current_storeRank_nodata_global: 'Current StoreRank is exclusively available when selecting market as Global.',
  dbi_only_global_rankings: 'This store list only has global rankings, no country rankings.',
  dbi_only_global_rankings_epic: 'The Epic Store only has global rankings, no country rankings.',

  dbi_by_region: 'By Region',
  dbi_by_country: 'By Country',
  dbi_shortcut: 'Shortcut',
  dbi_date_range: 'Date Range',

  dbi_calculation_method_average: 'Average',

  // App Magic Tag 筛选器
  dbi_appmagic_themes: 'Themes',
  dbi_appmagic_features: 'Features',
  dbi_appmagic_ip: 'IP',
  dbi_appmagic_settings: 'Settings',
  dbi_appmagic_art_styles: 'Art Styles',

  // Game Comparison Feature
  dbi_game_comparison: 'Game Comparison',
  dbi_game_comparison_tooltip: 'Navigate to Game Comparison page, compare this game with its competitors.',
  dbi_vs_button_tooltip: 'Navigate to Game Comparison page, compare this game with its competitors below.',
  dbi_compare_competitors: 'Compare competitors',
  dbi_worldwide_update_time: 'Updated daily at 12:00 UTC+8',
  dbi_worldwide_tab_steam: 'Steam',
  dbi_worldwide_tab_roblox: 'Roblox',
  dbi_worldwide_mobile_breakouts: 'Mobile Breakouts',
  dbi_worldwide_mobile_tip_new_label: 'New:',
  dbi_worldwide_mobile_tip_new_desc: ' Launched within T-7 days and entered the App Store Top 50 Grossing.',
  dbi_worldwide_mobile_tip_surge_label: 'Surge:',
  dbi_worldwide_mobile_tip_surge_desc: ' Games that climbed the App Store Grossing compared to T-1 day (Ranks 1-5: up ≥5 spots; Ranks 6-20: up ≥10 spots; Ranks 21-50: up ≥20 spots).',
  dbi_worldwide_grossing: 'Grossing',
  dbi_worldwide_grossing_upper: 'GROSSING',
  dbi_worldwide_steam_breakouts: 'Steam Breakouts',
  dbi_worldwide_steam_tip_new_desc: ' Games launched within T-7 days that ranked in the Top 20 for Steam PCU over the last 24 hours.',
  dbi_worldwide_steam_tip_surge_desc: ' Games in the Top 10 for Steam PCU that climbed ≥ 5 spots compared to T-1 day.',
  dbi_worldwide_steam_anomaly_title: 'Trend Analysis',
  dbi_worldwide_steam_pcu_source: 'PCU data is sourced from SteamDB and calculated based on updates over the past 24 hours.',
  dbi_worldwide_steam_hot_games: 'Trending Games',
  dbi_worldwide_steam_pcu_24h: '24H PCU',
  dbi_worldwide_steam_change: 'Change',
  dbi_worldwide_steam_release_days: 'Since Release',
  dbi_worldwide_days_unit: 'Days',
  dbi_worldwide_game_release: 'Game Release:',
  dbi_worldwide_iegg_genre: 'IEGG Genre',
  dbi_worldwide_roblox_breakouts: 'Roblox Breakouts',
  dbi_worldwide_roblox_tip_new_desc: 'Games entering the Roblox CCU Top 10 for the first time.',
  dbi_worldwide_roblox_tip_surge_desc: 'Games entering the Roblox CCU Top 10 that were unranked over the past year.',
  dbi_worldwide_roblox_hot_games: 'Trending Games',
  dbi_worldwide_roblox_ccu_24h: '24H CCU',
  dbi_worldwide_roblox_change: 'Change',
  dbi_worldwide_roblox_release_days: 'Since Release',
  dbi_worldwide_roblox_gameplay: 'Gameplay',
  dbi_worldwide_roblox_social: 'Social',
  dbi_worldwide_roblox_theme: 'Theme',
  dbi_worldwide_roblox_rng: 'RNG',
  dbi_worldwide_roblox_elements: 'Mechanics',
  dbi_worldwide_roblox_gameplay_tip: 'Roblox gameplay tags are provided by the Game Research Center. They are part of a taxonomy developed by experts based on a comprehensive evaluation of Roblox experiences.',
  dbi_worldwide_roblox_elements_tip: 'Roblox mechanics tags are provided by the Game Research Center. They are part of a taxonomy developed by experts based on a comprehensive evaluation of Roblox experiences.',
  dbi_worldwide_roblox_ccu_source: 'Roblox CCU data is sourced from official online player counts and updated every 10 minutes.',
  dbi_reuse_page_title_roblox_game_rank: 'Roblox Game Rank',
  dbi_reuse_page_title_roblox_top_charts: 'Roblox Top Charts',
  dbi_roblox_device: 'Device',
  dbi_roblox_device_option_all: 'All Devices',
  dbi_roblox_device_option_console: 'Console',
  dbi_roblox_device_option_computer: 'Computer',
  dbi_roblox_device_option_entry_level_phone: 'Entry-level Phone',
  dbi_roblox_device_option_entry_level_tablet: 'Entry-level Tablet',
  dbi_roblox_device_option_standard_phone: 'Standard Phone',
  dbi_roblox_device_option_standard_tablet: 'Standard Tablet',
  dbi_roblox_device_option_vr: 'VR',
  dbi_roblox_up_date: 'Up Date',
  dbi_roblox_genre: 'Roblox Genre',
  dbi_roblox_server_size: 'Server Size',
  dbi_roblox_supported_features: 'Supported Features',
  dbi_roblox_support_feature_voice_chat: 'Voice Chat',
  dbi_roblox_support_feature_camera: 'Camera',
  dbi_roblox_top_charts_metric_pcu: 'PCU',
  dbi_roblox_top_charts_metric_players: 'CCU',
  dbi_roblox_top_charts_metric_visits: 'Visits',
  dbi_roblox_top_charts_metric_likes: 'Likes',
  dbi_roblox_top_charts_metric_dislikes: 'Unlike',
  dbi_roblox_top_charts_metric_favorites: 'Favorites',
  dbi_roblox_top_charts_metric_section_title: 'Metric',
  dbi_roblox_top_charts_sorted_by: 'Sorted by Roblox {sortField}',
  dbi_roblox_top_charts_sort_field_ccu: 'Roblox CCU',
  dbi_roblox_game_rank_section_title: 'Rank',
  dbi_roblox_game_rank_sorted_by: 'Sorted by {sortField}',
  dbi_roblox_game_rank_sort_field: '#rank',
  dbi_roblox_rank_list: 'Rank',
  dbi_roblox_download_game_info: 'Game information',
  dbi_roblox_download_classification: 'Classification',
  dbi_roblox_download_rank_selected_count: '{count} charts selected',
  dbi_roblox_download_search: 'Search',
  dbi_roblox_rank_category_popular: 'Popular',
  dbi_roblox_rank_category_genres: 'Genres',
  dbi_roblox_rank_category_earnings: 'Earnings',
  dbi_roblox_rank_category_featured: 'Featured',
  dbi_roblox_rank_source_most_popular: 'Most Popular',
  dbi_roblox_rank_source_top_playing_now: 'Top Playing Now',
  dbi_roblox_rank_source_top_trending: 'Top Trending',
  dbi_roblox_rank_source_up_and_coming: 'Up-and-Coming',
  dbi_roblox_rank_source_fun_with_friends: 'Fun with Friends',
  dbi_roblox_rank_source_trending_music_experiences: 'Trending Music Experiences',
  dbi_roblox_rank_source_trending_in_rpg: 'Trending in RPG',
  dbi_roblox_rank_source_trending_in_sports_racing: 'Trending in Sports & Racing',
  dbi_roblox_rank_source_trending_in_shooter: 'Trending in Shooter',
  dbi_roblox_rank_source_trending_in_action: 'Trending in Action',
  dbi_roblox_rank_source_trending_in_adventure: 'Trending in Adventure',
  dbi_roblox_rank_source_trending_in_entertainment: 'Trending in Entertainment',
  dbi_roblox_rank_source_trending_in_obby_platformer: 'Trending in Obby & Platformer',
  dbi_roblox_rank_source_trending_in_party_casual: 'Trending in Party & Casual',
  dbi_roblox_rank_source_trending_in_puzzle: 'Trending in Puzzle',
  dbi_roblox_rank_source_trending_in_roleplay_avatar_sim: 'Trending in Roleplay & Avatar Sim',
  dbi_roblox_rank_source_trending_in_shopping: 'Trending in Shopping',
  dbi_roblox_rank_source_trending_in_simulation: 'Trending in Simulation',
  dbi_roblox_rank_source_trending_in_strategy: 'Trending in Strategy',
  dbi_roblox_rank_source_trending_in_survival: 'Trending in Survival',
  dbi_roblox_rank_source_top_earning: 'Top Earning',
  dbi_roblox_rank_source_top_paid_access: 'Top Paid Access',
  dbi_roblox_rank_source_more_when_you_subscribe: 'More When You Subscribe',
  dbi_roblox_rank_source_top_rated: 'Top Rated',
  dbi_roblox_rank_source_top_revisited: 'Top Revisited',
  dbi_roblox_rank_source_learn_and_explore: 'Learn & Explore',
  dbi_roblox_rank_source_most_popular_desc:
    'Top experiences sorted by daily users. These experiences have at least 5,000 daily users, are within the top 10% of daily active users, or are among the top 30 most played experiences. The order of these experiences is subject to the device and location filters applied to this page.',
  dbi_roblox_rank_source_top_playing_now_desc:
    'Top experiences sorted by the number of concurrent users.',
  dbi_roblox_rank_source_top_trending_desc:
    'Top experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_up_and_coming_desc:
    'Top experiences published within the last 28 days sorted by user growth.',
  dbi_roblox_rank_source_fun_with_friends_desc:
    'Experiences with at least 5000 users daily, sorted by the proportion of time spent as groups of friends. These experiences have at least 5,000 daily users, are within the top 10% of daily active users, or are among the top 30 most played experiences. The order of these experiences is subject to the device and location filters applied to this page.',
  dbi_roblox_rank_source_trending_music_experiences_desc:
    'Music experiences with at least 2500 users daily that have the biggest relative increase in time spent over the last 2 weeks.',
  dbi_roblox_rank_source_trending_in_rpg_desc:
    'Top RPG experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_sports_racing_desc:
    'Top Sports and Racing experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_shooter_desc:
    'Top Shooter experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_action_desc:
    'Top Action experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_adventure_desc:
    'Top Adventure experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_entertainment_desc:
    'Top Entertainment experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_obby_platformer_desc:
    'Top Obby and Platformer experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_party_casual_desc:
    'Top Party and Casual experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_puzzle_desc:
    'Top Puzzle experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_roleplay_avatar_sim_desc:
    'Top Roleplay and Avatar Sim experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_shopping_desc:
    'Top Shopping experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_simulation_desc:
    'Top Simulation experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_strategy_desc:
    'Top Strategy experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_trending_in_survival_desc:
    'Top Survival experiences with the largest relative increase in daily active users over the past week.',
  dbi_roblox_rank_source_top_earning_desc:
    'Experiences sorted by total robux spent in the last 7 days. These experiences have at least 5,000 daily users, are within the top 10% of daily active users, or are among the top 30 most played experiences. The order of these experiences is subject to the device and location filters applied to this page.',
  dbi_roblox_rank_source_top_paid_access_desc:
    'Paid access experiences sorted by daily revenue.',
  dbi_roblox_rank_source_more_when_you_subscribe_desc:
    'Experiences with at least 5000 users daily, sorted by time spent from users with subscriptions.',
  dbi_roblox_rank_source_top_rated_desc:
    'Experiences with at least 5000 users daily, that have both a high number and proportion of likes.',
  dbi_roblox_rank_source_top_revisited_desc:
    'Experiences sorted by the proportion of users who come back after a week. These experiences have at least 5,000 daily users, are within the top 10% of daily active users, or are among the top 30 most played experiences. The order of these experiences is subject to the device and location filters applied to this page.',
  dbi_roblox_rank_source_learn_and_explore_desc:
    'Experiences with learning elements that inspire your creativity and critical thinking.',
  dbi_worldwide_new_entry: 'New',
  dbi_worldwide_tag_new: 'New',
  dbi_worldwide_tag_surge: 'Surge',
  dbi_worldwide_contact_text: 'For any questions, please reach out to delvinding or velvetjiang.',
  dbi_less: 'Less',
};
